import React, { Component } from 'react';
import styled from 'styled-components';
import Select from 'react-select';
import { Button, Input, Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import CBGU from './CBGU';
import PortionInputs from './PortionInputs';
import Tags from './Tags';
import Buttons from './Buttons';
import {
  EATING_TAGS,
  DISH_TYPE_TAGS,
  CATEGORY_INGREDIENTS,
} from '../../../../constants/appConstants';
import ProductsListModal from './Products/ProductsListModal';
import { toastError } from '../../../../utils/toastMessage';
import { createDish, editSelectedDish } from '../../../../actions/dishEdit';
import { getTags } from '../../../../actions/tags/getTags';
import { getAllMealTypes } from '../../../../actions/getAllMealTypes';
import { getDishTemplate } from '../../../../actions/dishTemplate';
import { filterDish, getProducts } from '../../../../actions/dishSearch';
import FoodNavigationsScreen from '../../../Common/FoodNavigatonsScreen';
import { getDishesFromId, setDishUpgrade } from '../../../../actions/dishes';

class ChangeDishPages extends Component {
  constructor(props) {
    super(props);
    let dishes = props.dish;
    if (!props.dish) {
      dishes = {
        name: '',
        calories: '',
        image: null,
        recepie: {
          products: [],
          text: null,
        },
        min_weight: '',
        avg_weight: '',
        max_weight: '',
        proteins: '',
        carbohydrates: '',
        fats: '',
        tags: [],
        time: '',
      };
    }
    const ownModalDish = JSON.parse(JSON.stringify(dishes));
    let defaultDishTypeId = null;
    const dishTypeTag = props.tags.find((tag) => tag.category_id === DISH_TYPE_TAGS);
    if (dishTypeTag) defaultDishTypeId = dishTypeTag.tag_id;
    if (ownModalDish && ownModalDish.tags.length) {
      const defaultDishTypeTag = ownModalDish.tags.find(
        (tag) => tag.category_id === DISH_TYPE_TAGS,
      );
      if (defaultDishTypeTag) defaultDishTypeId = defaultDishTypeTag.tag_id;
    } else {
      // eslint-disable-next-line no-lonely-if
      if (dishTypeTag) ownModalDish.tags.push(dishTypeTag);
    }
    this.state = {
      stateDish: ownModalDish,
      dishTypeTagId: defaultDishTypeId,
      error: true,
      isOpenProductsListModal: false,
      isValid: false,
      isNewDish: !props.dish,
    };
  }

  componentDidMount() {
    const {
      tags,
      getTags,
      getAllMealTypes,
      getDishTemplate,
      filterDish,
      searchParam,
      filterParam,
      order,
      getProducts,
      sortParam,
      getDishesFromId,
    } = this.props;
    const sort = sortParam.slice(0, -1);
    filterDish(searchParam, filterParam, sort, order, true);
    !tags.length && getTags();
    getAllMealTypes();
    getDishTemplate();
    getProducts(); // get products
    this.validateDish();
    // eslint-disable-next-line react/destructuring-assignment
    const Dishid = this.props.match.params.id;
    if (Dishid) {
      getDishesFromId(Dishid);
    }
  }

  setQueryParamsDish = (dishes) => {
    const ownModalDish = JSON.parse(JSON.stringify(dishes));
    let defaultDishTypeId = null;
    if (ownModalDish && ownModalDish.tags && ownModalDish.tags.length) {
      const defaultDishTypeTag = ownModalDish.tags.find(
        (tag) => tag.category_id === DISH_TYPE_TAGS,
      );
      if (defaultDishTypeTag) defaultDishTypeId = defaultDishTypeTag.tag_id;
    }
    this.setState({ stateDish: ownModalDish });
    this.setState({ dishTypeTagId: defaultDishTypeId });
  };

  handleAddProductClick = () => {
    const { stateDish } = this.state;
    const newDish = stateDish;
    newDish.recepie.products.push({
      name: '',
      pivot: {
        product_id: '',
        weight: '',
        measure_id: 1, // default
      },
    });
    this.setState({ stateDish: newDish });
  };

  setIsOpenProductsListModal = (isOpen) => {
    this.setState({ isOpenProductsListModal: isOpen });
  };

  handleRemoveProductClick = (removedProduct) => {
    const { stateDish } = this.state;
    const newDish = stateDish;
    newDish.recepie.products = newDish.recepie.products.filter(
      (product) => product.name !== removedProduct.name,
    );
    this.setState({ stateDish: newDish });
    this.validateDish();
  };

  checkIncludesTags = (tagId) => {
    const {
      stateDish: { tags },
    } = this.state;
    if (tags) return !!tags.find((tag) => tag.tag_id === +tagId);
    return false;
  };

  handleInput = (e, type, index = null) => {
    const { stateDish } = this.state;
    const { tags } = this.props;
    const newDish = stateDish;
    switch (type) {
      case 'name':
        newDish.name = e.target.value;
        break;
      case 'image':
        // eslint-disable-next-line prefer-destructuring
        newDish.image = e.target.files[0];
        break;
      case 'text':
        newDish.recepie.text = e.target.value;
        break;
      case 'products_weight':
        newDish.recepie.products[index].pivot.weight = e.target.value;
        break;
      case 'tags':
        if (this.checkIncludesTags(e.target.value)) {
          newDish.tags = newDish.tags.filter((tag) => tag.tag_id !== +e.target.value);
        } else {
          if (!newDish.tags) newDish.tags = [];
          const choosedTag = tags.find((tag) => tag.tag_id === +e.target.value);
          newDish.tags.push(choosedTag);
        }
        break;
      case 'cbgu':
        switch (index) {
          case 'c':
            newDish.calories = parseFloat(e.target.value);
            newDish.recepie.calories = e.target.value;
            break;

          case 'b':
            newDish.recepie.proteins = e.target.value;
            break;

          case 'g':
            newDish.recepie.fats = e.target.value;
            break;

          case 'u':
            newDish.recepie.carbohydrates = e.target.value;
            break;
          default:
            break;
        }
        break;
      case 'portion':
        switch (index) {
          case 'minWeigth':
            newDish.min_weight = +e.target.value;
            break;
          case 'weight':
            newDish.avg_weight = +e.target.value;
            break;
          case 'maxWeigth':
            newDish.max_weight = +e.target.value;
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
    this.setState({ stateDish: newDish }, () => this.validateDish());
  };

  onChangeProduct = (productObj, productIndex) => {
    if (!productObj) return;
    this.setState({ isValid: false }, () => this.validateDish());
    const { stateDish } = this.state;
    const newDish = stateDish;
    newDish.recepie.products[productIndex].id = productObj.id;
    newDish.recepie.products[productIndex].pivot.product_id = productObj.id;
    newDish.recepie.products[productIndex].name = productObj.name;
    newDish.recepie.products.map((uniqueProduct, uniqueIndex) => {
      return newDish.recepie.products.map((product, otherIndex) => {
        if (uniqueIndex !== otherIndex && product.name !== '') {
          if (uniqueProduct.name === product.name) {
            this.setState({ isValid: true }, () => this.validateDish());
          }
        }
        return null;
      });
    });
    this.setState({ stateDish: newDish });
  };

  onChangeProductMeasure = (measure, productIndex) => {
    const { stateDish } = this.state;
    const newDish = stateDish;
    newDish.recepie.products[productIndex].pivot.measure_id = measure.id;
    if (newDish.recepie.products[productIndex].pivot.measure_id === 5) {
      // по вкусу
      newDish.recepie.products[productIndex].pivot.weight = '0';
    }
    this.setState({ stateDish: newDish });
  };

  deleteImage = () => {
    const { stateDish } = this.state;
    const newDish = stateDish;
    newDish.image = '';
    this.fileInput.value = '';
    this.setState({ stateDish: newDish });
  };

  validateDish = () => {
    const {
      stateDish: {
        name,
        calories,
        recepie: { products, carbohydrates, fats, proteins },
        min_weight,
        avg_weight,
        max_weight,
        tags = [],
      },
      isValid,
    } = this.state;
    let isCorrectRecipeData =
      name !== '' &&
      calories >= 0 &&
      carbohydrates !== '' &&
      fats !== '' &&
      proteins !== '' &&
      min_weight &&
      min_weight !== '' &&
      avg_weight &&
      avg_weight !== '' &&
      max_weight &&
      max_weight !== '' &&
      products.length;

    if (isValid) isCorrectRecipeData = false;

    if (!tags.find((tag) => tag.category_id === EATING_TAGS)) isCorrectRecipeData = false;
    if (!tags.find((tag) => tag.category_id === DISH_TYPE_TAGS)) isCorrectRecipeData = false;
    if (!tags.find((tag) => tag.category_id === CATEGORY_INGREDIENTS)) isCorrectRecipeData = false;

    this.setState({ error: !isCorrectRecipeData });
  };

  editSelectedDish = () => {
    const { editSelectedDish } = this.props;
    const { error, stateDish } = this.state;
    if (error) return false;
    stateDish.image = stateDish.image === null ? '' : stateDish.image;
    if (!this.isCorrectDishProducts(stateDish.recepie.products)) return;
    editSelectedDish(stateDish);
  };

  createDish = () => {
    const { createDish } = this.props;
    const { error, stateDish } = this.state;
    if (error) return false;
    if (!this.isCorrectDishProducts(stateDish.recepie.products)) return;
    createDish(stateDish);
  };

  onInputBlur = () => {
    const { stateDish } = this.state;
    stateDish.recepie.products.map((product) => {
      let weight = [];
      if (product.length !== 0) weight = product.pivot.weight.split('');
      if (product.pivot.weight && weight[0] === '0' && weight[1] !== '.') {
        weight.splice(1, 0, '.');
        product.pivot.weight = +weight.join('');
      }
      if (product.pivot.weight && weight[0] === '.') {
        weight.splice(0, 0, '0');
        product.pivot.weight = +weight.join('');
      }
      if (product.pivot.measure_id === 5) {
        // по вкусу
        product.pivot.weight = '0';
      }
    });
    this.setState({ stateDish: stateDish });
  };

  isCorrectDishProducts = (dishProducts) => {
    const { products } = this.props;
    for (let i = 0; i < dishProducts.length; i++) {
      // find dish product in total list products
      const findedProduct = products.find((product) => product.id === dishProducts[i].id);
      if (!findedProduct || !dishProducts[i].name) {
        toastError('Все поля названий ингридиентов должны быть заполнены.', 'Ошибка');
        return false;
      }
      if (!dishProducts[i].pivot.weight) {
        toastError(
          'Все поля весов ингридиентов должны быть заполнены. 0 - если выбрана специфическая мера (по вкусу и пр.)',
          'Ошибка',
        );
        return false;
      }
      if (!dishProducts[i].pivot.measure_id) {
        toastError('У каждого ингридиента должно быть выбрано значение меры.', 'Ошибка');
        return false;
      }
      if (!dishProducts[i].pivot.product_id || !dishProducts[i].id) {
        toastError(
          'Список ингридиентов не корректен. Перепроверьте его и попробуйте снова',
          'Ошибка',
        );
        return false;
      }
      if (dishProducts[i].pivot.measure_id !== 5 && dishProducts[i].pivot.weight <= 0) {
        toastError(
          'Вес ингридиентов должен быть больше 0. 0 - если выбрана специфическая мера "по вкусу"',
          'Ошибка',
        );
        return false;
      }
    }

    return true;
  };

  onChangeDishType = (tagObj) => {
    const { stateDish } = this.state;
    const newDish = stateDish;
    newDish.tags = newDish.tags.filter((tag) => tag.category_id !== DISH_TYPE_TAGS);
    newDish.tags.push(tagObj);
    this.setState(
      {
        dishTypeTagId: tagObj.tag_id,
        stateDish: newDish,
      },
      () => {
        this.validateDish();
      },
    );
  };

  render() {
    const {
      stateDish,
      dishTypeTagId,
      isOpenProductsListModal,
      error,
      isValid,
      isNewDish,
    } = this.state;
    const { tags, measures, products, isDishReadyToUpgrade, setDishUpgrade, dish } = this.props;
    if (dish && dish.name && isDishReadyToUpgrade && !stateDish.name) {
      this.setQueryParamsDish(dish);
      setDishUpgrade();
      this.validateDish();
    }

    return (
      <React.Fragment>
        <ChangePagesContect>
          <FoodNavigationsScreen />
          <PopupTitle>{isNewDish ? 'Добавить блюдо' : 'Редактировать блюдо'}</PopupTitle>
          <Row>
            <Label htmlFor="nameDish">
              Название<Message>*</Message>
            </Label>
            <NameDishInput
              type="text"
              placeholder="Название"
              name="nameDish"
              value={stateDish.name}
              onChange={(e) => this.handleInput(e, 'name')}
            />
          </Row>
          <Row>
            <Label htmlFor="uploadImage">Изображение</Label>
            <ImageBlock>
              {stateDish.image && (
                <DishImage
                  src={
                    typeof stateDish.image === 'object'
                      ? URL.createObjectURL(stateDish.image)
                      : stateDish.image
                  }
                />
              )}
              <input
                style={{ display: 'none' }}
                type="file"
                name="file"
                accept="image/*"
                onChange={(e) => this.handleInput(e, 'image')}
                // eslint-disable-next-line no-return-assign
                ref={(fileInput) => (this.fileInput = fileInput)}
              />
              <ButtonWrapper>
                <ImageButton onClick={() => this.fileInput.click()}>
                  {stateDish.image ? 'Изменить изображение' : 'Загрузить изображение'}
                </ImageButton>
                {stateDish.image && (
                  <ImageButtonDelete onClick={this.deleteImage}>
                    Удалить изображение
                  </ImageButtonDelete>
                )}
              </ButtonWrapper>
            </ImageBlock>
          </Row>
          <Row>
            <Label htmlFor="recepieTextarea">Рецепт</Label>
            <RecepieTextArea
              name="recepieTextarea"
              value={stateDish.recepie && stateDish.recepie.text ? stateDish.recepie.text : ''}
              onChange={(e) => this.handleInput(e, 'text')}
            />
          </Row>
          <Row>
            <IngririentsActionsBlock>
              <IngredientsLabel>Ингредиенты на 100 г. блюда</IngredientsLabel>
              <WrapIngredientAction>
                <StyledLink
                  to="/сreateIngredient"
                  // disabled
                >
                  Создать ингредиент
                </StyledLink>
              </WrapIngredientAction>
              <WrapIngredientAction>
                <Button fluid color="blue" onClick={() => this.setIsOpenProductsListModal(true)}>
                  Все ингредиенты
                </Button>
              </WrapIngredientAction>
            </IngririentsActionsBlock>
            <ProductsBlock name="productsBlock">
              {stateDish &&
                stateDish.recepie &&
                stateDish.recepie.products.map((product, i) => {
                  return (
                    // eslint-disable-next-line react/no-array-index-key
                    <ProductsItem key={i}>
                      <Select
                        placeholder="Название"
                        value={product.pivot.product_id}
                        clearable={false}
                        onChange={(productObj) => this.onChangeProduct(productObj, i)}
                        onInputChange={this.onProductFind}
                        valueKey="id"
                        labelKey="name"
                        options={products}
                        style={{
                          width: 150,
                          backgroundColor: isValid ? 'rgba(235, 71, 52, 0.4)' : '#FFFFFF',
                        }}
                      />
                      <Input
                        placeholder="Вес"
                        type="number"
                        style={{ width: 100 }}
                        value={product.pivot.weight > 0 && +product.pivot.weight}
                        onChange={(e) => this.handleInput(e, 'products_weight', i)}
                        onBlur={this.onInputBlur}
                      />
                      <Select
                        placeholder="Мера"
                        clearable={false}
                        valueKey="id"
                        labelKey="measure"
                        style={{ width: 150 }}
                        options={measures}
                        isSearchable={false}
                        value={product.pivot.measure_id}
                        onChange={(measureObj) => this.onChangeProductMeasure(measureObj, i)}
                      />
                      <Button
                        color="red"
                        icon
                        onClick={() => this.handleRemoveProductClick(product)}
                      >
                        <Icon name="delete" />
                      </Button>
                    </ProductsItem>
                  );
                })}
              <Button color="green" onClick={this.handleAddProductClick}>
                Добавить ингредиент
              </Button>
            </ProductsBlock>
          </Row>

          <Row>
            <Label htmlFor="cbguBlock">КБЖУ</Label>
            <CBGU
              calories={stateDish.recepie.calories}
              proteins={stateDish.recepie.proteins}
              fats={stateDish.recepie.fats}
              carbohydrates={stateDish.recepie.carbohydrates}
              handleInput={(e, type, index) => this.handleInput(e, type, index)}
            />
          </Row>
          <Row>
            <Label>Порция</Label>
            <PortionInputs
              minWeigth={stateDish.min_weight}
              weight={stateDish.avg_weight}
              maxWeigth={stateDish.max_weight}
              handleInput={(e, type, index) => this.handleInput(e, type, index)}
            />
          </Row>
          <WrapRecipeOptions>
            <TagsTitle>
              Выберите вид блюда:<Message>*</Message>
            </TagsTitle>
            <Select
              placeholder="Выберите вид блюда..."
              clearable={false}
              labelKey="name"
              valueKey="tag_id"
              options={tags.filter((tag) => tag.category_id === DISH_TYPE_TAGS)}
              value={dishTypeTagId}
              onChange={this.onChangeDishType}
            />
          </WrapRecipeOptions>
          <WrapRecipeOptions>
            <TagsTitle>Выберите теги блюда:</TagsTitle>
          </WrapRecipeOptions>
          <Tags
            tags={tags}
            checkIncludesTags={this.checkIncludesTags}
            handleInput={(e) => this.handleInput(e, 'tags')}
          />
          <Buttons
            creatingNewDish={isNewDish}
            editSelectedDish={this.editSelectedDish}
            createDish={this.createDish}
            error={error}
          />
          {isOpenProductsListModal && (
            <ProductsListModal
              isOpen={isOpenProductsListModal}
              onClose={() => this.setIsOpenProductsListModal(false)}
            />
          )}
        </ChangePagesContect>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  measures: state.dishSearch.measures,
  products: state.dishSearch.products,
  dish: state.dishEdit.dish,
  dishTags: state.dishEdit.dishTags,
  mealTypes: state.dishEdit.mealTypes,
  tags: state.getTags.tags,
  searchParam: state.searchParams.searchParam,
  filterParam: state.searchParams.filterParam,
  order: state.searchParams.order,
  sortParam: state.searchParams.sortParam,
  isDishReadyToUpgrade: state.reducers.isDishReadyToUpgrade,
});

const mapDispatchToProps = (dispatch) => {
  return {
    editSelectedDish: (data) => {
      dispatch(editSelectedDish(data));
    },
    createDish: (data) => {
      dispatch(createDish(data));
    },
    setDishUpgrade: () => {
      dispatch(setDishUpgrade());
    },
    getTags: () => {
      dispatch(getTags());
    },
    getAllMealTypes: () => {
      dispatch(getAllMealTypes());
    },
    getDishTemplate: () => {
      dispatch(getDishTemplate());
    },
    filterDish: (searchValue, tags, sortParam, order, rendering) => {
      dispatch(filterDish(searchValue, tags, sortParam, order, rendering));
    },
    getProducts: (name) => {
      dispatch(getProducts(name));
    },
    getDishesFromId: (id) => {
      dispatch(getDishesFromId(id));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ChangeDishPages);

const ChangePagesContect = styled.div`
  width: 80%;
  margin: 0 auto;
`;

const PopupTitle = styled.h1`
  font-size: 30px;
  text-align: center;
  margin: 20px auto !important;
  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
  @media screen and (max-width: 400px) {
    font-size: 15px;
  }
`;

const Row = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  margin: 35px 0;
  @media (max-width: 768px) {
    flex-flow: row wrap;
  }
`;

const NameDishInput = styled.input`
  display: inline-block;
  width: 60%;
  margin: 0 5%;
  height: 30px;
  text-align: center;
  @media (max-width: 768px) {
    width: 90%;
  }
`;

const Label = styled.label`
  display: inline-block;
  width: 25%;
  text-align: center;
  left: 5%;
  @media (max-width: 768px) {
    width: 100%;
    left: 0;
    padding-left: 10%;
    margin-bottom: 10px;
    text-align: left;
  }
`;

const RecepieTextArea = styled.textarea`
  display: inline-block;
  width: 60%;
  margin: 0 5%;
  height: 150px;
  resize: none;
  @media (max-width: 768px) {
    width: 90%;
  }
`;

const ProductsBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 60%;
  margin: 0 5%;

  @media (max-width: 768px) {
    width: 90%;
  }
`;

const ProductsItem = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 5px 0;
`;

const Message = styled.span`
  display: inline-block;
  color: #ea1b00;
  margin: 0 3px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 490px) {
    flex-direction: column;
  }
`;

const ImageButton = styled.button`
  background: #157aac;
  margin: 10px 10px 0 10px;
  min-width: 170px;
  height: 30px;
  cursor: pointer;
  padding: 0 10px;
  border: none;
  color: #fff;
  border-radius: 5px;
  &:hover {
    background: #17ade3;
    border: 1px solid #000542;
  }
`;

const ImageButtonDelete = ImageButton.extend`
  background: #db2828;
  &:hover {
    background: #d01919;
  }
`;

const ImageBlock = styled.div`
  display: flex;
  margin: 5px auto;
  justify-content: center;
  align-items: space-between;
  flex-direction: column;
`;

const TagsTitle = styled.h4`
  font-size: 25px;
  margin: 10px auto;
`;

const WrapRecipeOptions = styled.div`
  width: 90%;
  margin: 15px auto;
`;

const DishImage = styled.img`
  max-width: 300px;
  @media screen and (max-width: 320px) {
    max-width: 250px;
  }
`;

const IngririentsActionsBlock = styled.div`
  margin-top: 10px;
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 5%;
  @media screen and (max-width: 768px) {
    margin: 10px auto;
  }
`;

const IngredientsLabel = styled.div``;

const WrapIngredientAction = styled.div`
  margin-top: 15px;
  width: 100%;
`;

const StyledLink = styled(Link)`
  padding: 8px;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 800;
  background: #21ba45;
  color: #fff;
  border-radius: 5px;
  &:hover {
    background: #16ab39;
    color: #ffffff;
  }
  @media (max-width: 345px) {
    font-size: 14px;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Dishes/Popups/Dish/ChangeDishPages.jsx